import React, {useState, useEffect} from 'react';
import {Link} from "react-router-dom"
import {useAuth} from "./../contextos/AuthContext";
import {Header, Titulo, ContenedorHeader, ContenedorBotones} from '../elementos/Header'
import {ContenedorBotonesLista, BotonEditar, BotonEliminar} from '../elementos/ElementosDeLista'
import {ReactComponent as IconoEditar} from '../imagenes/editar.svg'
import {ReactComponent as IconoBorrar} from '../imagenes/borrar.svg'
import API from '../servicios/api';
import Boton from '../elementos/Boton'
import Alerta from '../elementos/Alerta'
import Cargando from '../elementos/Cargando'
import VentanaModal from '../elementos/VentanaModal'

const ListarUsuario = () => {
    const [datosCargados, setdatosCargados] = useState(false);
    const [usuarios, setUsuarios] = useState([]);
    const [estadoAlerta, setEstadoAlerta] = useState(false);
    const [alerta, setAlerta] = useState({});
    const [estadoModal, setEstadoModal] = useState(false);
    const [idEliminar, setidEliminar] = useState(0);
    const {idUsuario} = useAuth();
    
    //Este hook se ejecuta solamente al primer renderizado
    useEffect(() => {
        cargarDatos();
    }, []);

    //Este hook se ejecuta solamente al primer renderizado
    const cargarDatos = () => {
        fetch(API+"?consultarUsuarios")
        .then(respuesta=>respuesta.json())
        .then((datosRespuesta)=>{
            setdatosCargados(true);
            setUsuarios(datosRespuesta);
        })
        .catch(console.log)
    }

    const handleModal = (id) => {
        setidEliminar(id);
        setEstadoModal(true);
    }

    const borrarRegistro = () => {
        setEstadoModal(false);
        setEstadoAlerta(false);
        setAlerta({});

        if(idUsuario === idEliminar){
            setEstadoAlerta(true);
            setAlerta({
                tipo: 'error',
                mensaje: 'No es posible eliminar al usuario activo.'
            });
            return;
        }

        fetch(API+"?borrarUsuario="+idEliminar)
        .then(respuesta=>respuesta.json())
        .then((datosRespuesta)=>{
            if(datosRespuesta.success === 1){
                setEstadoAlerta(true);
                setAlerta({
                    tipo: 'exito',
                    mensaje: 'Usuario eliminado correctamente.'
                });
                cargarDatos();
            }
            else{
                setEstadoAlerta(true);
                setAlerta({
                    tipo: 'error',
                    mensaje: 'No es posible eliminar este Usuario.'
                });
            }
        })
        .catch(console.log)
    }

    if(!datosCargados){
        return(
            <Cargando />
        );
    }
    else{
        return (
            <>
                <Header>
                    <ContenedorHeader>
                        <Titulo>Lista de Usuarios</Titulo>
                        <ContenedorBotones>
                            <Boton to="/crear-usuario" primario="true">Agregar Usuario</Boton>
                        </ContenedorBotones>
                    </ContenedorHeader>
                </Header>

                {usuarios.success === 0 ?
                <p className='ms-3'>No hay información para mostrar.</p>
                :
                <div className="contenedor-tabla">
                    <div className="card card-tamano">
                        <div className="card-body">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Nombres</th>
                                        <th>Correo</th>
                                        <th>Tipo de Usuario</th>
                                        <th>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        usuarios.map(
                                            (usuario)=>(
                                                <tr key={usuario.Usu_ID}>
                                                    <td>{usuario.Usu_Nombres}</td>
                                                    <td>{usuario.Usu_Correo}</td>
                                                    <td>{usuario.Tip_Descripcion}</td>
                                                    <td>
                                                        <ContenedorBotonesLista>
                                                            <BotonEditar title="Editar Usuario" as={Link} to={"/editar-usuario/"+usuario.Usu_ID}>
                                                                <IconoEditar />
                                                            </BotonEditar>
                                                            
                                                            <BotonEliminar title="Eliminar Usuario" onClick={() => handleModal(usuario.Usu_ID)}>
                                                                <IconoBorrar />
                                                            </BotonEliminar>
                                                        </ContenedorBotonesLista>
                                                    </td>
                                                </tr>
                                            )
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                }
                <Alerta 
                        tipo={alerta.tipo}
                        mensaje={alerta.mensaje}
                        estadoAlerta={estadoAlerta}
                        setEstadoAlerta={setEstadoAlerta}
                />

                <VentanaModal
                        mensajeHeader="Eliminar Usuario"
                        mensajeBody="¿Está seguro de eliminar el usuario?"
                        estadoModal={estadoModal}
                        setEstadoModal={setEstadoModal}
                        handleConfirm={borrarRegistro}
                />
            </>
        );
    }
}
 
export default ListarUsuario;